Core.PortalCheckout = {
    SHOW: 'show',
    REMOVE: 'remove',

    init: function () {
        Core.PortalCheckout.Cache = {
            $calendar: $('input.portal-checkout__purchase-calendar'),
            $accordionContent: $('.portal-checkout__accordion-content'),
            $checkoutQuantity: $('.portal-checkout__purchase-column--qty input:visible'),
            $inputQuantity: $(".portal-checkout__purchase-qty"),
            $selectUserCheckout: $('.btnSelectUser'),
            $clientDetailRadio: $('.portal-checkout__client-detail--radio input[type=radio]'),
            $shippingCostRadio: $('input[name="shippingCostOptions"]'),
            $btnClientDetails: $('#btnClientDetails'),
            $btnCheckoutSize: $('#frmSaveCart .btn-checkout-size'),
            $hidNewClient: $('#hidNewClient'),

            // Hospital Process
            $hospitalLocationDetailsWrap: $('.portal-checkout__accordion-content__hospital-location-details'),
            $hospitalLocationDetails: $('.portal-checkout__location--list-details'),
        };

        $("input[type=checkbox], input[type=radio]").uniform();

        // cart functions
        this.checkoutCalendar();
        this.initAndChangeNumericTextBox();
        this.removeProductFromCart();
        this.saveCartValidate();
        this.checkCartItem();

        // client functions
        this.userCheckoutSelected();
        this.updateUserListDisplay();
        this.saveClientSubmit();
        this.saveClientValidate();
        this.saveConfirmValidate();
        this.saveStaffValidate();
        this.favBtnHandle();
        this.handleBtnSubmit();
        this.handleClientRefrenceNo();
        this.hideClientMissingError();

        // Hospital Process
        this.handleHospitalLocationDetails();
        this.listenHomeMod();
        this.initComments();
        
        var stockIntegration = new Core.StockIntegration('checkout');
        stockIntegration.init();

        var resizeTimer;
        $(window).on('resize', function (e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                Core.PortalCheckout.updateClassRemove();
            }, 100);
        });
    },

    isEmptyCart: function() {
        return ($('#frmSaveCart').text().trim() === 'You do not have any items in your cart');
    },

    refreshItems: function() {
        var api = $('#frmSaveCart').data('refreshcartApi');

        if (!api) {
            return;
        }

        $.get(api, function (response) {
            $('#frmSaveCart').replaceWith(response);
            Core.PortalCheckout.init();

            Core.PortalCheckout.isEmptyCart()
                && Core.PortalAccordion.disableNextAll($('#checkoutCart'));
        });
    },

    listenHomeMod: function() {
        document.addEventListener('aidacare.home-mod-completed', Core.PortalCheckout.refreshItems);
    },

    initComments: function() {
        var btnCheck = Core.CheckoutCommentContinueBtnCheck();

        Array
            .from(document.querySelectorAll('[data-comment="true"]'))
            .forEach(function(elem) {
                Core.CheckoutComment(elem, btnCheck).init();
            });
    },

    checkoutCalendar: function () {
        Core.PortalCheckout.Cache.$calendar.each(function () {
            var id = this.getAttribute('id');

            if (id) {
                if (Core.IsMobile()) {
                    //set mobile native datepicker
                    Core.PortalCheckout.initNativeDatepicker(this, id);
                } else {
                    Core.PortalCheckout.initKendoDatepicker(this, id);
                }
            }
        });

        Core.PortalCheckout.setCalendarVal();
    },

    //init mobile native datepicker
    initNativeDatepicker: function (input, id) {
        var onChange = function ($this) {
            var $parent = $($this.parents('.inputwrap')[0])
                , $errorWrap = $parent.find('.inputwrap-error')
                , calVal = $this.val();

            if ($parent.hasClass('is-required')) {
                if (!calVal) {
                    Core.PortalCheckout.insertErrorMsg($errorWrap, "Required");
                } else {
                    $errorWrap.empty();
                }
            }

            //rent, start date handler
            if ($el.hasClass('has-endDate')) {
                var $endDate = $el.parents('.portal-checkout__purchase-column--startdate').siblings('.portal-checkout__purchase-column--enddate').find('input.endDate')
                    , minVal = moment(calVal).add(1, 'd')._d;
                $endDate.attr('min', moment(minVal).format('YYYY-MM-DD'));
            }

            //rent, end-date handler
            if ($el.hasClass('endDate')) {
                var $startDate = $el.parents('.portal-checkout__purchase-column--enddate').siblings('.portal-checkout__purchase-column--startdate').find('input.startDate')
                    , maxVal = moment(calVal).subtract(1, 'd')._d;
                $startDate.attr('max', moment(maxVal).format('YYYY-MM-DD'));
            }

            //rent-to-own
            var weekToOwn = $el.data('weekstoown')
                , newWeekToOwn;

            if (typeof weekToOwn !== "undefined") {
                var $span = $el.closest('tr').find('.portal-checkout__purchase-column--ownby span');
                if (weekToOwn > 0)
                    newWeekToOwn = Core.PortalCheckout.weekCalculation(calVal, weekToOwn);
                else
                    newWeekToOwn = Core.PortalCheckout.formatDate(calVal);

                $span.html(newWeekToOwn);
            }

        };

        var $el = $("#" + id)
            , today = moment(new Date)
            , elVal = $el.val();

        $el.attr('type', 'date');
        $el.attr('min', moment().format('YYYY-MM-DD'));
        if (elVal) {
            //format from server side on loads
            var date = moment(elVal, 'DD/MM/YYYY');
            $el.val(date.format('YYYY-MM-DD'));
        }

        $el.on('change blur', function () {
            onChange($(this));
        });
    },

    initKendoDatepicker: function (input, id) {
        var isEndDate = input.classList.contains('endDate')
            , today = moment(new Date)
            , $el = $("#" + id)
            , curVal = $el.val();

        $el.kendoDatePicker({
            format: "dd/MM/yyyy",
            start: Core.PortalCheckout.todayDate(),
            footer: "<button onclick='Core.PortalCheckout.clearCalendar(" + id + ")'>Clear</button>",
            min: isEndDate ? today.add(1, 'd')._d : today._d,
            change: function (e) {
                //use trigger blur so it only called once if calendar input change
                $(this.element).trigger('blur');
            }
        });

        //make the input readonly
        $el.prop('readonly', true);
        $el.on('click', function () {
            $(this).data('kendoDatePicker').open();
        });

        $el.on('blur', function (e) {
            Core.PortalCheckout.calendarOnBlur($(this));
        });
    },

    setCalendarVal: function () {
        Core.PortalCheckout.Cache.$calendar.each(function () {
            var id = this.getAttribute('id')
                , today = moment(new Date)
                , $el = $("#" + id)
                , curVal = $el.val();

            var elObj = $el.data('kendoDatePicker');
            if (!Core.IsMobile() && curVal) {
                curVal = Core.IsMobile() ? moment(curVal, "YYYY-MM-DD") : moment(curVal, "D/MM/YYYY");
                //check if curval less than today
                if (curVal.diff(today) < 0) {
                    elObj.value(today.format('DD/MM/YYYY'));
                    $el.trigger('blur');
                } else {
                    elObj.value(curVal.format('DD/MM/YYYY'));
                }
            }
        });
    },

    calendarOnBlur: function ($this) {
        var $parent = $($this.parents('.inputwrap')[0])
            , $errorWrap = $parent.find('.inputwrap-error');

        if ($parent.hasClass('is-required')) {
            if (!$this.val()) {
                $this.addClass("error");
                Core.PortalCheckout.insertErrorMsg($errorWrap, "Required");
            } else {
                $this.removeClass("error");
            }
        }

        //check if date is valid first
        var dateVal = moment($this.val(), 'DD/MM/YYYY', true);
        if ($this.val()) {
            if (!dateVal.isValid()) {
                $this.addClass("error");
                Core.PortalCheckout.insertErrorMsg($errorWrap, "Invalid date");
            } else {
                $this.removeClass("error");
                $errorWrap.empty();
            }
        }

        Core.PortalCheckout.calendarOnChange($this.data('kendoDatePicker'));
    },

    calendarOnChange: function ($this) {
        var $el = $this.element
            , $span = $($el).closest('tr').find('.portal-checkout__purchase-column--ownby span')
            , calVal = $this.value();

        if (!calVal) {
            $span.html('');
            return;
        }

        //rent, start date handler
        if ($el.hasClass('has-endDate')) {
            var $end = $el.parents('.portal-checkout__purchase-column--startdate').siblings('.portal-checkout__purchase-column--enddate').find('input.endDate');
            var $endDate = $end.data('kendoDatePicker');
            var endVal = moment(calVal).add(1, 'd');
            $endDate.min(endVal._d);
            return;
        }

        //rent, end-date handler
        if ($el.hasClass('endDate')) {
            var $start = $el.parents('.portal-checkout__purchase-column--enddate').siblings('.portal-checkout__purchase-column--startdate').find('input.startDate');
            var $startDate = $start.data('kendoDatePicker');
            var maxVal = moment(calVal).subtract(1, 'd');
            $startDate.max(maxVal._d);
            return;
        }

        //rent-to-own
        var weekToOwn = $el.data("weekstoown")
            , newWeekToOwn;

        if (typeof weekToOwn !== "undefined") {
            if (weekToOwn > 0)
                newWeekToOwn = Core.PortalCheckout.weekCalculation(calVal, weekToOwn);
            else
                newWeekToOwn = Core.PortalCheckout.formatDate(calVal);

            $span.html(newWeekToOwn);
        }
    },

    clearCalendar: function (el) {
        var $errorWrap = $(el).find('.inputwrap-error')
        $(el).data("kendoDatePicker").value(null);
    },

    insertErrorMsg: function ($el, txt) {
        $el.empty();
        $el.append($("<label class=\"error\">" + txt + "</label>"));
    },

    handleBtnSubmit: function () {
        Core.PortalCheckout.Cache.$btnCheckoutSize.unbind();
        Core.PortalCheckout.Cache.$btnCheckoutSize.on('click', function (e) {
            e.preventDefault();
            var success = true;

            var generateErrorTxt = function ($el, txt) {
                Core.PortalCheckout.insertErrorMsg($el, txt);
                success = false;
            };

            var currentDate = new Date()
                , dateFormat = Core.IsMobile() ? "YYYY-MM-DD" : "DD/MM/YYYY";
            currentDate.setHours(0, 0, 0, 0);

            $('.rent-row').each(function () {
                var $this = $(this)
                    , startObj = $this.find('input.startDate')[0]
                    , $start = startObj.value;

                if ($start === "") {
                    startObj.classList.add('error');
                    generateErrorTxt($this.find('.start-date-error'), 'Required');
                    return;
                } else {
                    startObj.classList.remove('error');
                }

                var $from = moment($start, dateFormat, true);
                if (!$from.isValid()) {
                    generateErrorTxt($this.find('.start-date-error'), 'Invalid date');
                    return;
                }

                var endObj = $this.find('input.endDate')[0]
                    , $end = endObj.value
                    , $to = moment($end, dateFormat, true);
                if ($end && !$to.isValid()) {
                    endObj.classList.add('error');
                    generateErrorTxt($this.find('.end-date-error'), 'Invalid date');
                    return;
                } else {
                    endObj.classList.remove('error');
                }
            });

            $('.rent-own-row').each(function () {
                var $this = $(this)
                    , startObj = $this.find('input.startDate')[0]
                    , $start = startObj.value;
                if ($start === "") {
                    startObj.classList.add('error');
                    generateErrorTxt($this.find('.start-date-error'), 'Required');
                    return;
                } else {
                    startObj.classList.remove('error');
                }

                var $from = moment($start, dateFormat, true);
                if (!$from.isValid()) {
                    generateErrorTxt($this.find('.start-date-error'), 'Invalid date');
                    return;
                }
            });

            //go to first error
            var $error = $('.inputwrap-error label.error');
            if ($error.length > 0) {
                var offset = Core.IsMobile() ? 80 : 50;
                var scrollTop = $error.first().offset().top - offset;
                Core.ScrollToView(scrollTop);
            }

            if (success)
                $('#frmSaveCart').trigger('submit');
        });
    },

    getDynamicPrice: function(sku, qty) {
        // var url = 'https://run.mocky.io/v3/cc977cc6-69b0-4f0e-93a2-abe7e32a6586';
        var url = '/cart/getpricebyquantity';
        var data = { "sku": sku, "qty": qty };
        return $.post(url, data);
    },

    initAndChangeNumericTextBox: function () {
        function getSku(elem) {
            var inputCodeName = $(elem).attr('name');
            var sku = $('[name="' + inputCodeName.replace('Quantity', 'Code') + '"]').val();

            return sku;
        }

        function setPrice(elem, newPrice) {
            $(elem).attr('price', newPrice);
        }

        function setLabelPrice(sku, newLabel) {
            $('[data-price-label="' + sku + '"]').text(newLabel);
        }

        function onChangeQty() {
            var self = this;
            var elem = this.element;
            var sku = getSku(elem);
            var isDynamic = $(elem).data('dynamicPrice') || false;
            var qty = $(elem).val();

            // force to have value '1' if input is blank
            if (!qty) {
                qty = 1;
                this.value(1);
            }

            if (! isDynamic) {
                Core.PortalCheckout.updateTotalAndSubtotal(self);
                return;
            }

            Core.PortalCheckout.getDynamicPrice(sku, qty)
                .done(function(data) {
                    if (data == null) {
                        return;
                    }

                    data.unitPriceLabel
                        && setLabelPrice(sku, data.unitPriceLabel);

                    data.unitPrice
                        && setPrice(elem, data.unitPrice);
                })
                .always(function() {
                    Core.PortalCheckout.updateTotalAndSubtotal(self);
                });

            // check stock
            if (!!$('#portal-checkout').data('check-local-stock-api')) {                
                var stockIntegration = new Core.StockIntegration('checkout');
                stockIntegration.updateStock(false, $(elem).closest('.portal-checkout__row'));
            }
        }

        Core.PortalCheckout.Cache.$inputQuantity.kendoNumericTextBox({
            min: 1,
            format: "#",
            decimals: 0,
            step: 1,
            change: onChangeQty,
            spin: onChangeQty
        });
    },

    /**
     * Show or remove the confirmation remove message.
     * This allow the user to stop the remove action.
     *
     * @param {jquery} $row - the row to attach or remove the message
     * @param {string} doShow Core.PortalCheckout.SHOW || .Core.PortalCheckout.REMOVE
     */
    showRemoveMessage: function ($row, doShow) {
        doShow = doShow === Core.PortalCheckout.SHOW; //set default to true

        if (doShow) {
            var removeMsgTmpl = '<p class="removeMessage">This item has been removed from your cart. <button type="button" class="btn-undo">Undo</button></p>';
            $row.find('td:first-child').append(removeMsgTmpl);
            $row.addClass('on-removed');
        } else {
            $row.find('.removeMessage').remove();
            $row.removeClass(function (index, css) {
                return (css.match(/(^|\s)rorcls\S+/g) || []).join(' ');
            });
            $row.removeClass('on-removed');
        }

        Core.PortalCheckout.updateClassRemove();
    },

    updateClassRemove: function () {
        var elements = $('tr.on-removed');

        // add new class name
        var cssStyleshets = [];
        for (var a = 0; a < elements.length; a++) {
            var el = $(elements[a]);
            var elHeight = el.outerHeight() / 2;
            el.addClass("rorcls-" + a);
            cssStyleshets.push(".rorcls-" + a.toString() +
                " .removeMessage{ height:" + elHeight +
                "px !important; top:" + el.position().top +
                "px; padding-top:" + (elHeight - 10) +
                "px  !important; padding-bottom:10px  !important;}");
        }
        // remove existing stylesheets
        $('#overlayElementsStyles').remove();
        // add new stylesheets
        if (elements.length > 0) {
            $('<style type="text/css" id="overlayElementsStyles">' + cssStyleshets.join('') + '</style>').appendTo($('head'));
        }
    },

    /*

        After deleting a item on the cart check if there are
        still items that make the cart valid.

        Eg: if i've got only a service eg home modification
        doesn't make sense to have shipping which is
        stricly product related.

        to debug:
        document
            .addEventListener(
                'aidacare.is-invalid-shipping',
                () => console.log('invalid shipment'))

        @event aidacare.is-invalid-shipping
        @var response
        @see response from ore.PortalCheckout.deleteItem

     */
    propagateIsInvalidShipping: function(response) {
        var dispatchInvalidShipping = function() {
            var custEvent = new CustomEvent('aidacare.is-invalid-shipping');
            document.dispatchEvent(custEvent);
        };

        var isInvalidShipping = function() {
            return response
                && response.IsInvalidShipping
                && response.IsInvalidShipping.toString().toLowerCase().trim() === 'true';
        }

        isInvalidShipping()
            && dispatchInvalidShipping();
    },

    removeProductFromCart: function () {
        $('.portal-checkout__purchase-remove').unbind('click');
        $('.portal-checkout__purchase-remove').on('click', function (e) {
            e.stopPropagation();

            var $el = $(this);
            var btnNext = document.querySelector('.btn-checkout-size');
            var $row = $el.closest("tr");
            var $qtyInput = $row.find('input.portal-checkout__purchase-qty[type=text]:visible');
            var $hiddenQty = $row.find('input.portal-checkout__purchase-qty[type=text][id*="__Quantity"]');

            $row.addClass('on-removed');
            $hiddenQty.data('default-qty', $qtyInput.val());

            Core.PortalCheckout.showRemoveMessage($row, Core.PortalCheckout.SHOW);
            btnNext.disabled = true;

            var doRemoveItem = function () {
                var id = $row.attr('data-id');
                Core.PortalCheckout.deleteItem(id, function (response) {
                    Core.PortalCheckout.propagateIsInvalidShipping(response);

                    // remove item from flyout
                    var $rowFlyOut = $('#cart-playout').find('tr.table-yourcart-row-item[data-id=' + id + ']');
                    Core.FlyoutButtons.removeItemRow($rowFlyOut);

                    Core.PortalCheckout.refreshItems();
                });
            };

            var executeRemove = setTimeout(function () {
                //remove item
                doRemoveItem();

                //hide removeMessage
                Core.PortalCheckout.showRemoveMessage($row, Core.PortalCheckout.REMOVE);
            }, 2000);

            $row.find('.btn-undo').on('click', function () {
                //cancel out delete item
                clearTimeout(executeRemove);
                Core.PortalCheckout.showRemoveMessage($row, Core.PortalCheckout.REMOVE);
                btnNext.disabled = false;
            });
        });
    },

    removeItemRow: function ($row) {
        //remove item row
        var $wrap = $row.closest('.portal-checkout__purchase-item');
        $row.remove();

        //if there's no item left, delete whole section (buy, rent, or rent-to-own)
        if ($wrap.find('tr.portal-checkout__row').length === 0) {
            $wrap.remove();

            //remove total summary
            if ($('.buy-row').length === 0) $('.portal-checkout__purchase-shipping-summary--value-buy').parent().remove();
            if ($('.rent-row').length === 0) $('.portal-checkout__purchase-shipping-summary--value-rent').parent().remove();
            if ($('.rent-own-row').length === 0) $('.portal-checkout__purchase-shipping-summary--value-renttoown').parent().remove();
        }

        Core.PortalCheckout.checkCartItem();
    },

    calculateRow: function (inpObj) {
        var elem = $(inpObj.element);
        var price = elem.attr('price') || 0;

        return price * inpObj._value;
    },

    //calculate sub-total per section (buy, rent, or rent-to-own)
    //inpObj's value could be tableId (buy, rent, or rent-to-own)
    calculateSection: function (el) {
        var $parent = $(el).hasClass('portal-checkout__purchase-table') ? el : $(el.element);
        //var $parent = elem;
        if (!$parent.hasClass('portal-checkout__purchase-table')) {
            $parent = $parent.closest('.portal-checkout__purchase-table');
        }

        var $quantities = $parent.find('input.portal-checkout__purchase-qty[type=text][id*="__Quantity"]')
            , amount = 0;

        for (var i = 0; i < $quantities.length; i++) {
            var $el = $($quantities[i])
                , qty = $el.closest('.portal-checkout__purchase-column').find('input[type="text"].portal-checkout__purchase-qty:visible').val() || 0
                , price = $el.attr('price');

            amount += (price * qty);
        };

        return amount;
    },

    //update text total per row and subtotal per section
    updateTotalAndSubtotal: function (inpObj) {
        var elem = $(inpObj.element);
        var _self = Core.PortalCheckout
            , $col = elem.closest('.portal-checkout__purchase-column')
            , $subTotalHTML = $col.siblings('.portal-checkout__purchase-column--subtotal').find('span')
            , rowTotal = _self.formatMoney(_self.calculateRow(inpObj), 2, '$', ',', '.');

        $subTotalHTML.html(rowTotal);

        var $parents = elem.closest('.portal-checkout__purchase-table')
            , $totalHTML = $parents.find('.portal-checkout__purchase-totalprice span')
            , summaryTotal = _self.formatMoney(_self.calculateSection(inpObj), 2, '$', ',', '.');

        $totalHTML.html(summaryTotal);

        if ($parents.attr('id') == "table-purchaseitems") {
            $('.portal-checkout__purchase-shipping-summary--value-buy span').html(summaryTotal);
        }

        if ($parents.attr('id') == "table-rentitems") {
            $('.portal-checkout__purchase-shipping-summary--value-rent span').html(summaryTotal + "/week");
        }

        if ($parents.attr('id') == "table-renttoownitem") {
            $('.portal-checkout__purchase-shipping-summary--value-renttoown span').html(summaryTotal + "/week");
        }

        _self.updateAmountToBePaid();
    },

    //update Amount to be paid now
    updateAmountToBePaid: function () {
        var _self = Core.PortalCheckout
            , $tblPurchase = $('#table-purchaseitems')
            , $tblRent = $('#table-rentitems')
            , $tblRentOwn = $('#table-renttoownitem')
            , amount = 0;

        if ($tblPurchase.length) amount += _self.calculateSection($tblPurchase);
        if ($tblRent.length) amount += _self.calculateSection($tblRent);
        if ($tblRentOwn.length) amount += _self.calculateSection($tblRentOwn);

        $('#spnBuyTotal').html(_self.formatMoney(amount, 2, '$', ',', '.'));
    },

    deleteItem: function (id, successCb) {
        Core.ShowPageLoading();
        var postcode = "";
        var org = "";

        $.ajax({
            type: "GET",
            url: '/Cart/removefromcart',
            data: {
                code: id,
                postcode: postcode,
                organization: org,
                hideFreight: false,
                orderOrganization: "",
                therapistID: ""
            },
            success: function (response) {
                Core.CartFlyout.init();
                if (successCb) successCb(response);
                Core.HidePageLoading();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //todo: do something
                Core.HidePageLoading();
            }
        });
    },

    userCheckoutSelected: function () {
        $('.btnSelectUser').on('click', function () {

            var $el = $(this),
                $parent = $el.closest('tr'),
                $wrap = $el.closest('table');

            if (!$parent.hasClass('selected')) {
                $wrap.find('tr.selected').removeClass('selected');
                $parent.addClass('selected');
            }

            $("#AddNewClientContent").slideDown();
        });
    },

    updateExistingClientAddNewClientRadio: function(radioName) {
        Array
            .from(document.querySelectorAll('[name=clientDetailRadio]'))
            .forEach(function(itm) {
                itm.checked = (itm.value === radioName);
            })

        $('[name=clientDetailRadio]').uniform();
    },

    hideClientMissingError: function() {
      $("#clientMissingError").html('');
      $("#clientMissingError").hide();
    },

    updateUserListDisplay: function () {
        Core.PortalCheckout.Cache.$clientDetailRadio.unbind();
        Core.PortalCheckout.Cache.$clientDetailRadio.on('change', function () {
            var $el = $(this),
                $label = $el.closest('.portal-checkout__client-detail--radio'),
                $content = $label.siblings('.portal-checkout__client-detail--content'),
                $hiddenValNewClient = $('#hidNewClient');

            if ($el.val() === "Add New Client") {
                $hiddenValNewClient.attr("value", "true");
                $('#divSearchContact').slideUp();
                $('#divClientDetails').slideDown();
                $("#frmClientRefNo").find("#ContactID").val('');
                Core.PortalCheckout.resetForm($('#AddNewClientContent').find('form'));
            }
            else {
                $hiddenValNewClient.attr("value", "false");
                $('#divSearchContact').slideDown();
                $('#divClientDetails').slideUp(0);
            }


            if ($('#ClientReferenceNumber').val() == "") {
                $('#checkOutClientDetailsReadonly').find('input[type="text"],input[type="email"], input[type="tel"], textarea').prop('readonly', true);
                $('#checkOutClientDetailsReadonly').find('#DVADOB, #DVADOD').prop('disabled', true);
                $('#checkOutClientDetailsReadonly').find('input[type="checkbox"], input[type="radio"]').prop('disabled', true).uniform();
                $("#ClientReferenceNumber").prop('readonly', false);

                // Comment out dropdown select cause we don't use state dropdown anymore.
                // $('#checkOutClientDetailsReadonly').find('select').prop('disabled', true);
                // $('#checkOutClientDetailsReadonly').find('select').each(function(index, elem) {
                //     $(elem).data("kendoDropDownList")
                //         && ( $(elem).data("kendoDropDownList").enable(false)
                //            , $(elem).data("kendoDropDownList").value(''));
                // });
                // $('#checkOutClientDetailsReadonly').find('select').data("kendoDropDownList").enable(false);
            }

            Core.PortalCheckout.hideClientMissingError();
            $("#clientRefrenceNumberError").html('');

            Core.PortalCheckout.updateExistingClientAddNewClientRadio($el.val());
        });
    },

    resetForm: function ($form) {
        $form.find('input:text, input:password, input[type=tel], input[type=email], select, textarea').val('');
        $form.find('input:radio, input:checkbox')
            .prop('checked', false).prop('selected', false);
    },

    saveClientSubmit: function () {
        $("#btnClientDetails").unbind();
        $("#btnClientDetails").on('click', function (e) {
            var behalf = $('[data-id="onBehalfOrganization"]').val();
            $('#OnBehalfOrganization').val(behalf);

            if ($("#hidSelectedContactID").val() === "" && $("[name= clientDetailRadio][value='Existing Client']").is(":checked")) {

                if (!$(".existingClientSearch").find(".error").length) {
                    $(".existingClientSearch").append("<label for=\"clientDetailRadio\" class=\"error\">Please select existing client</label>");
                    Core.PortalCheckout.hideClientMissingError();
                }

                $("html, body").animate({ scrollTop: $("[name= clientDetailRadio]").offset().top - 30 }, 300);
                e.preventDefault();
            }
            else if ($("#divClientDetails:visible").length === 0) {

                $("#clientMissingError").html("Please add client");
                $("#clientMissingError").show();
                $("html, body").animate({ scrollTop: $("[name= clientDetailRadio]").offset().top - 30 }, 300);
                e.preventDefault();
            }
            // TODO: validate autocomplete
            else {

                if ($(".existingClientSearch").find(".error").length) {
                    $(".existingClientSearch .error").remove();
                }
                Core.PortalCheckout.hideClientMissingError();

                var isSaveContactValid = $('#frmSaveContact').valid();
                var isSaveStaffValid = $('#frmSaveStaff').valid();

                // STR -- DVA ERAP validation

                var isDVAValid = Core.DVAInformation.isValid({
                    dvaCardType: "#DVACardType",
                    dvaDOB: "#DVADOB",
                    dvaRCF: "#yes_rcf",

                    dvaFundingOther: '#yes_DVAFundingOther',
                    dvaFundingOtherType: '#DVAFundingOtherType',

                    // dvaADL: "#DVAActivityOfDailyLiving",
                    // dvaBEH: "#DVABehaviour",
                    // dvaCHC: "#DVAComplexHealthCare"
                });

                var isDVADischargedValid = Core.DVAInformation.isValidDischarged({
                    dvaDOD: "#DVADOD",
                    dvaHospitalDischarge: "#DVAHospitalDischarge",
                });

                // END -- DVA ERAP validation


                if (isSaveStaffValid && isDVAValid && isDVADischargedValid) {
                    $("#frmSaveContact").trigger('submit');
                    $("#frmSaveStaff").trigger('submit');
                }
            }
        });
    },

    saveConfirmSubmit: function () {
        $("#btnConfirmDetails").unbind();
        $("#btnConfirmDetails").on('click', function (e) {
            if ($('#frmConfirmOrder').valid() && $('#frmConfirmOrder').valid()) {
                $("#frmConfirmOrder").trigger('submit');
            }
        });
    },

    saveCartValidate: function () {
        $("#frmSaveCart").validate({
            focusInvalid: false,
            invalidHandler: function (form, validator) {

                if (!validator.numberOfInvalids())
                    success = true;
                else {
                    $("div.validation-summary-errors").html('');
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                    },
                        300);
                }
            }
        });
    },

    saveClientValidate: function () {
        $("#frmSaveContact").validate({
            ignore: ':hidden',
            focusInvalid: false,
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    success = true;
                // scroll to view handled on DVAInformation.js
                // else {
                //     $("div.validation-summary-errors").html('');
                //     $('html, body').animate({
                //         scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                //     }, 300);
                // }
            }
        });
    },

    saveConfirmValidate: function () {
        $("#frmConfirmOrder").validate({
            ignore: ':hidden',
            focusInvalid: false,
            invalidHandler: function (form, validator) {

                if (!validator.numberOfInvalids())
                    success = true;
                else {
                    $("div.validation-summary-errors").html('');
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                    },
                        300);
                }
            }
        });
    },

    saveStaffValidate: function () {
        $("#frmSaveStaff").validate({
            focusInvalid: false,
            invalidHandler: function (form, validator) {

                if (!validator.numberOfInvalids())
                    success = true;
                else {
                    $("div.validation-summary-errors").html('');
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                    },
                        300);
                }
            }
        });
    },

    triggerCheckout: function () {
        Core.PortalCheckout.Cache.$btnCheckoutSize.unbind();
        Core.PortalCheckout.Cache.$btnCheckoutSize.on('click', function (e) {
            e.preventDefault();
            if ($('.futureDate').val() === "") {
                $('.futureDate').closest('.form-input').append("<label for=\"futureDate\" class=\"error\">Required</label>");
                return false;
            }
            var currentDate = new Date();
            var selectedDate = new Date($('.futureDate').val());

            if (selectedDate < currentDate) {
                $('.futureDate').closest('.form-input').append("<label for=\"futureDate\" class=\"error\">Must be future date</label>");
                return false;
            }
        });
    },

    showNotificationPopup: function (popupLabel, contentText, type) {
        var typeClass;

        switch (type) {
            case "warning":
                typeClass = "warning-popup-content";
                break;
            case "error":
                typeClass = "error-popup-content";
                break;
            case "valid":
                typeClass = "valid-popup-content";
                break;
            default:
                typeClass = false;
                break;
        }

        var kendoWindow = $("<div />").kendoWindow({
            actions: ["Close"],
            title: popupLabel,
            resizable: false,
            modal: true,
            deactivate: function () {
                this.destroy();
            }
        });

        var template = kendo.template($("#notificationTemplate").html());

        kendoWindow.data("kendoWindow")
            .content(template(contentText))
            .center().open();

        if (typeClass != false) {
            kendoWindow
                .parent()
                .addClass(typeClass)
                .end();
        }

        kendoWindow
            .find(".btnNotifOk")
            .on('click', function () {
                kendoWindow.data("kendoWindow").close();
            })
            .end();
    },

    todayDate: function () {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = dd + '/' + mm + '/' + yyyy;
        return today;
    },

    weekCalculation: function (date, weeks) {
        var newdate = new Date(date);
        var numOfDays = weeks * 7;
        newdate.setDate(newdate.getDate() + numOfDays);
        return ('0' + newdate.getDate()).slice(-2) + "/" + ('0' + (newdate.getMonth() + 1)).slice(-2) + "/" + newdate.getFullYear();
    },

    formatDate: function (date) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(date);
        return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
    },

    formatMoney: function (number, places, symbol, thousand, decimal) {
        number = number || 0;
        places = !isNaN(places = Math.abs(places)) ? places : 2;
        symbol = symbol !== undefined ? symbol : "$";
        thousand = thousand || ",";
        decimal = decimal || ".";
        var negative = number < 0 ? "-" : "",
            i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
    },

    disabledButton: function (button) {
        $(button).addClass('disabled').prop('disabled', true);
    },

    enabledButton: function (button) {
        $(button).removeClass('disabled').prop('disabled', false);
    },

    checkCartItem: function () {
        //check if any iten exist, if not grey out continue button
        if ($('.portal-checkout__row').length === 0) {
            $('#frmSaveCart .btn-checkout-size').prop('disabled', true);
        } else {
            $('#frmSaveCart .btn-checkout-size').prop('disabled', false);
        }
    },

    favBtnHandle: function () {
        $('.portal-checkout__purchase-favourite').unbind('click');
        $('.portal-checkout__purchase-favourite').on('click', function () {
            Core.PortalCheckout.favouriteItem($(this).children(), function (response) {
                console.log(response);
            });
        });
    },

    favouriteItem: function ($btnFav, successCb) {
        Core.ShowPageLoading();
        var _$this = $btnFav,
            _$item = _$this.parents('tr'),
            _isFavourite = _$this.hasClass('icon-cart-fav'),
            $errorBox = $('#divCart .portal-error');

        var _apiUrl = _isFavourite ? '/cart/removefromfavourites' : '/cart/addtofavourites';

        $.ajax({
            url: _apiUrl,
            data: { code: _$item.data('id') },
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.WasSuccess) {
                    Core.ShowErrorMessage($errorBox, null, false);

                    if (_isFavourite) {
                        _$this.removeClass('icon-cart-fav').addClass('icon-fav');
                        _$this.parent().removeClass('active').attr('title', Core.Config.FavouriteText.Add);
                    }
                    else {
                        _$this.removeClass('icon-fav').addClass('icon-cart-fav');
                        _$this.parent().addClass('active').attr('title',  Core.Config.FavouriteText.Remove);
                    }
                } else {
                    Core.ShowErrorMessage($errorBox, {
                        title: Core.Config.FavouriteText.ErrorTitle,
                        message: data.Result
                    });
                }

                if (successCb) successCb(data);
                Core.HidePageLoading();
            },
            error: function (xhr, status, error) {
                Core.ShowErrorMessage($errorBox, {
                    title: Core.Config.FavouriteText.ErrorTitle,
                    message: [
                        xhr.responseText,
                        "Status: " + xhr.status,
                        "Error: " + error
                    ]
                });
                Core.HidePageLoading();
            }
        });
    },

    /*

        @TODO remove after integration Core.PortalCheckoutClientSearch

     */
    handleSelectClient: function () {
        $('#clientDetailListTable .pccdlt-row').on('click', function (e) {
            var form = $(this).find('.pccdlt-acts form');
            $(form).trigger('submit');
        });
    },

    handleClientRefrenceNo: function () {
        $('#ClientRefNo').on('change', function (e) {
            $("#frmClientRefNo").trigger('submit');
        });
    },


    /**


        Hospital Location Details


     */

    handleHospitalLocationDetails: function () {
        function isNull(el) {
            return !(el.html() + '').trim();
        }

        function getLocationData(locationID) {
            return (typeof window.hospitalLocationsData[locationID] !== 'undefined')
                ? window.hospitalLocationsData[locationID]
                : { name: '-', addr: '-', suburb: '-', state: '-', postcode: '-'};
        }

        function updateLocationDetailsForm(data) {
            details.find('#locationAddr').val(data.addr);
            details.find('#locationSuburb').val(data.suburb);
            details.find('#locationPostcode').val(data.postcode);

            details.find('#locationState').val(data.state);

            details.find('#locationState').data("kendoDropDownList") &&
                details.find('#locationState').data("kendoDropDownList").value(data.state);
        }

        function updateLocationDetails(val) {
            var data = getLocationData(val);

            updateLocationDetailsForm(data);
        }

        function onLocationChange(e) {
            updateLocationDetails(e.currentTarget.value);
        }

        var wrap = Core.PortalCheckout.Cache.$hospitalLocationDetailsWrap;
        var select = wrap.find('#LocationDetails');
        var details = Core.PortalCheckout.Cache.$hospitalLocationDetails;
        var pageLoadValue = select.val();

        if (isNull(wrap) || ! window.hospitalLocationsData) {
            return;
        }

        select.on('change', onLocationChange);

        pageLoadValue
            && updateLocationDetails(pageLoadValue);
    },
};

Core.PortalCheckoutTermsAndConditions = {
    init: function () {
        Core.PortalCheckoutTermsAndConditions.Cache = {
            $termAndConditionLink: $('.termAndConditionPopup'),
            $btnContinueShipping: $('#btnContinueShipping'),
            $btnAgreeShippingPopup: $('#btnAgreeShippingPopup'),
            $btnCancelPopup: $('#btnCancelShippingPopup'),
            $termsCheckbox: $('#termsAndConditionsCheckbox'),
            $btnPay: $('#btnPayNow'),
            $poNumber: $('.poNumber'),
            $formPayment: $('#frmConfirmOrder')
        };

        this.setPopup();
        this.handleTacCheckbox();
        this.handlePOChange();
        this.btnAgreeClickHandle();
        this.btnCancelClickHandle();
        this.btnSubmitHandle();
    },

    btnAgreeClickHandle: function () {
        Core.PortalCheckoutTermsAndConditions.Cache.$btnAgreeShippingPopup.on('click', function (e) {
            e.stopPropagation();
            Core.PortalCheckoutTermsAndConditions.checkTacCheckbox(true);
            Core.PortalCheckoutTermsAndConditions.showPopup($('#tacPopup'), false);
        });
    },

    btnCancelClickHandle: function () {
        Core.PortalCheckoutTermsAndConditions.Cache.$btnCancelPopup.on('click', function (e) {
            e.stopPropagation();
            Core.PortalCheckoutTermsAndConditions.checkTacCheckbox(false);
            Core.PortalCheckoutTermsAndConditions.showPopup($('#tacPopup'), false);
        });
    },

    handleTacCheckbox: function () {
        Core.PortalCheckoutTermsAndConditions.Cache.$termsCheckbox.on('change', function (e) {
            //keep chekbox unchanged
            var isChecked = this.checked;
            this.checked = !isChecked;
            $.uniform.update('#termsAndConditionsCheckbox');

            Core.PortalCheckoutTermsAndConditions.showPopup($('#tacPopup'), true);
        });
    },

    checkTacCheckbox: function (isSelected) {
        var _self = Core.PortalCheckoutTermsAndConditions;

        _self.Cache.$termsCheckbox.prop('checked', isSelected);
        _self.Cache.$btnContinueShipping.prop('disabled', !isSelected);
        $.uniform.update('#termsAndConditionsCheckbox');

        (_self.isPONumberRequired() && ! _self.isPONumberValid())
            ? _self.enablePayBtn(false)
            : _self.enablePayBtn(isSelected);
    },

    isPONumberRequired: function() {
        var _self = Core.PortalCheckoutTermsAndConditions;

        return _self.Cache.$poNumber &&
                _self.Cache.$poNumber.prop('required');
    },

    isPONumberValid: function() {
        var _self = Core.PortalCheckoutTermsAndConditions;

        return _self.Cache.$poNumber &&
                _self.Cache.$poNumber.val().length > 0;
    },

    /**
     * If the T&C section is present then use it during validation.
     *
     * Comunity portal for eg. doesn't have T&C.
     *
     * @return Boolean
     */
    isTermChecked: function() {
        var _self = Core.PortalCheckoutTermsAndConditions;

        return (_self.Cache.$termsCheckbox.length > 0)
                    ? _self.Cache.$termsCheckbox.prop('checked')
                    : true;
    },

    handlePOChange: function() {
        var _self = Core.PortalCheckoutTermsAndConditions;

        _self.Cache.$poNumber &&
            _self.Cache.$poNumber.keyup(function() {
                var invalidPO = (_self.isPONumberRequired() && ! _self.isPONumberValid());
                var invalidCheck = !_self.isTermChecked();

                (invalidPO || invalidCheck)
                    ? _self.enablePayBtn(false)
                    : _self.enablePayBtn(true);
            });
    },

    enablePayBtn: function (doEnable) {
        $('#btnPayNow').prop('disabled', !doEnable);

        if (typeof doEnable === "undefined" || doEnable === null) {
            doEnable = true;
        }

        var _self = Core.PortalCheckoutTermsAndConditions;

        if (doEnable) _self.Cache.$btnPay.removeClass('disabled').prop('disabled', false);
        else _self.Cache.$btnPay.addClass('disabled').prop('disabled', true);
    },

    initPopup: function ($popup, title) {
        var _self = Core.PortalCheckoutTermsAndConditions;
        var _width = 660, //Core.Config.CartNotification.Width,
            _height = 350;

        if (Core.IsMobile()) {
            _width = Core.Cache.$window.width();
        }

        $popup.kendoWindow({
            title: title,
            width: _width,
            //height: _height,
            visible: false,
            iframe: false,
            modal: true,
            resizable: false,
            actions: ["Close"],
            pinned: true,
            draggable: false,
            appendTo: '#page-wrap',
            animation: false,
        });

        var $closeBtn = $popup.find('.portal-modal__btn-close');

        if ($closeBtn) {
            $closeBtn.on('click', function () {
                _self.showPopup($popup, false);
            });
        }
    },

    showPopup: function ($popup, doShow) {
        doShow = doShow == undefined || null ? true : doShow; //set default to true/show

        var popupWindow = $popup.data("kendoWindow");
        popupWindow.wrapper.addClass('k-window-custom');

        if (doShow) {
            popupWindow.center().open();
        } else {
            popupWindow.close();
        }
    },

    setPopup: function () {
        var _self = Core.PortalCheckoutTermsAndConditions;

        _self.initPopup($('#tacPopup'), "TERMS & CONDITIONS");
        _self.initPopup($('#cardChangePopup'), "PAYMENT CONFIRMATION");

        _self.Cache.$termAndConditionLink.on('click', function (e) {
            e.preventDefault();
            Core.PortalCheckoutTermsAndConditions.showPopup($('#tacPopup'), true);
        });
    },

    checkDateValid: function () {
        var today = moment();
        var $selMonth = $('#paymentExpDate').data('kendoDropDownList');
        var $selYear = $('#paymentExpYear').data('kendoDropDownList');
        var selectedDate = moment($selYear.value() + '-' + $selMonth.value() + '-' + '01', 'YY-MM-DD');
        var isValid = selectedDate.isSameOrAfter(today, 'month');

        if (isValid) {
          $selMonth.wrapper && $selMonth.wrapper[0].classList.remove('error');
          $selYear.wrapper && $selYear.wrapper[0].classList.remove('error');
          $('#paymentExpError').addClass('hidden');
        }
        else {
          $selMonth.wrapper && $selMonth.wrapper[0].classList.add('error');
          $selYear.wrapper && $selYear.wrapper[0].classList.add('error');
          $('#paymentExpError').removeClass('hidden');
        }

        return isValid;
    },

    btnSubmitHandle: function () {
        var _self = Core.PortalCheckoutTermsAndConditions;

        _self.Cache.$btnPay.on('click', function (e) {
            e.preventDefault();
            var isCreditCard = $('input[name="checkoutPaymentMethod"]:checked').val() === "CreditCard";

            if (!isCreditCard) {
                _self.Cache.$formPayment.trigger('submit');
            } else {
                var isDateValid = _self.checkDateValid();
                if (_self.Cache.$formPayment.valid() && isDateValid) {
                    _self.showPopup($('#cardChangePopup'), true);
                } else {
                    //go to first error
                    var $error = $('.portal-checkout__cc-details input.error');
                    if ($error.length > 0) {
                        var offset = Core.IsMobile() ? 80 : 50;
                        var scrollTop = $error.first().offset().top - offset;
                        Core.ScrollToView(scrollTop);
                    }
                }
            }

        });

        $('#btnAgreeCardChange').on('click', function () {
            _self.Cache.$formPayment.trigger('submit');
            //show error box
        });
    }
};

Core.PortalCheckoutCheckboxToggle = {
    init: function () {
        Core.PortalCheckoutCheckboxToggle.Cache = {
            $toggleCbTrigger: $('#divClientDetails .toggle-cb-trigger')
        }

        this.handleToggleCheckbox();
        this.checkCheckbox();
    },

    handleToggleCheckbox: function () {
        Core.PortalCheckoutCheckboxToggle.Cache.$toggleCbTrigger.on('click', function () {
            Core.PortalCheckoutCheckboxToggle.toggleCheckbox($(this));
        });
    },

    toggleCheckbox: function ($el, cb) {
        var $targetName = $el.attr("id"),
            $targetTrigger = $el.find('input[type="checkbox"]'),
            $targetContent = $('div[data-toggle="' + $targetName + '"]'),
            isChecked = $targetTrigger.is(':checked');

        if (isChecked) {
            $targetContent.slideDown();
        } else {
            $targetContent.slideUp();
            Core.PortalCheckoutCheckboxToggle.clearForm($targetContent);
        }

        if (cb) cb(isChecked);
    },

    clearForm: function ($el) {
        $el.find(':input').each(function () {
            switch (this.type) {
                case 'password':
                case 'text':
                case 'textarea':
                case 'file':
                case 'select-multiple':
                case 'date':
                case 'number':
                case 'tel':
                case 'email':
                    $(this).val('');
                    break;
                case 'checkbox':
                case 'radio':
                    this.checked = false;
                    break;
                case 'select-one':
                    var kDropdown = $(this).data("kendoDropDownList");
                    if (kDropdown) kDropdown.select(0);
                    else $(this).prop('selectedIndex', 0);
                    break;
            }
        });
    },

    checkCheckbox: function () {
        Core.PortalCheckoutCheckboxToggle.Cache.$toggleCbTrigger.each(function () {
            var $el = $(this),
                $targetName = $el.attr("id"),
                $targetTrigger = $el.find('input[type="checkbox"]'),
                $targetContent = $('div[data-toggle="' + $targetName + '"]'),
                isChecked = $targetTrigger.is(':checked');

            if (isChecked) $targetContent.show();
            else $targetContent.hide();
        });

    }
};

Core.PortalCheckoutToggleRadioContent = {
    resetRadio: function ($radio) {
        var radioList = ".portal-radio__listbox-options-item";
        $radio.parents('.portal-checkout__listbox-options').find(radioList).removeClass('is-selected');
        $radio.parents(radioList).addClass('is-selected');
    },

    //clicking on the box
    handleRadioClick: function ($radioWrap) {
        $radioWrap.on('click', function (e) {
            if (e.target.getAttribute('type') == 'radio') return;

            var $this = $(this)
                , $radioGroup = $this.find('.toggle-radiogroup-content')
                , radioName = $radioGroup.prop('name');

            $radioGroup.trigger('change');
            $('input[name="' + radioName + '"]').prop('checked', false); //unchecked all first
            $radioGroup.prop('checked', true);
            $.uniform.update('input[name="' + radioName + '"]');
        });
    }

};

function getToggleSel(el) {
    return $(el).data('toggle');
}

function updateDeliveryOptionPrices(optionList) {
    function updateSingleOption(option) {
        if (!option || !option.id || !option.price) {
            return;
        }

        var elRadio = document.querySelector('[data-id="' + option.id + '"]');
        elRadio
            && (elRadio.dataset['price'] = option.price);

        var elLabel = document.querySelector('[data-price="' + option.id + '"]');
        elLabel
            && (elLabel.innerText = option.price);
    };

    optionList.forEach(updateSingleOption);
}

function updateElem(id, value) {
    var el = document.querySelector(id);

    el && (el.innerText = value);
}

function getSelectedPrice() {
    var priceElList = document.querySelectorAll('.toggle-radiogroup-content[data-price]');

    var selectedPrice = Array.from(priceElList).filter(function(el) { return el.checked === true; });

    return selectedPrice
            && selectedPrice[0]
            && selectedPrice[0].dataset
            && selectedPrice[0].dataset.price
                ? selectedPrice[0].dataset.price
                : '';
}

function updateShippingTotal() {
    var selectedPrice = getSelectedPrice();
    if (selectedPrice === '') {
        return;
    }

    updateElem('#shippingTotal', selectedPrice);
    updateElem('#spnShippingTotal', selectedPrice);
}

function resetShippingTotal() {
    updateElem('#shippingTotal', '$--.--');
    updateElem('#spnShippingTotal', '$--.--');
    updateElem('span[data-price]', '$--.--');
}

function getDeliveryPriceFromApi(postcode) {
    var elApi = document.querySelector('[data-postcodeapi]');

    elApi &&
    elApi.dataset &&
    elApi.dataset.postcodeapi &&
        ($.ajax({
            type: "GET",
            url: elApi.dataset.postcodeapi,
            data: {
                postcode: postcode
            },
            success: function (response) {
                //[{id: "c199888c-1f44-4cbd-8b9c-ebe59111a641", price: "$40.00"}]
                updateDeliveryOptionPrices(response)
                updateShippingTotal();
            }
        }));
}

Core.PortalCheckoutUpdateShippingCost = {
    init: function () {
        Core.PortalCheckoutUpdateShippingCost.Cache = {
            $shippingCostRadio: $('input[name="shippingCostOptions"]'),
            $deliverTo: $('input[name="deliveryTo"]'),
            $addAlternateContact: $('input[name="NewContactInfo"]'),
            $dynamicPostcode: $('input.dynamic-postcode'),
        }

        updateShippingTotal();

        this.updateShippingCost();
        this.updateDeliveryTo();
        this.updateContactInfo();
    },

    updateShippingCost: function () {
        Core.PortalCheckoutUpdateShippingCost.Cache.$shippingCostRadio.on('change', function () {
            var $el = $(this);
            var price = $el.data('price');

            $('#spnShippingTotal').html(price);
            $('#shippingTotal').html(price);
            $('#hidPrice').val(price);
            $("#hidShippingOptionId").val($el.data('id'));
            $('#hidShippingMethod').val($el.data('shippingmethod'));
            $('#hidUrgent').val($el.data('urgent'));
        });
    },

    updateDeliveryTo: function() {
        var $dt = Core.PortalCheckoutUpdateShippingCost.Cache.$deliverTo;
        var $dynamicPostcode = Core.PortalCheckoutUpdateShippingCost.Cache.$dynamicPostcode;

        function getFormElem(id) {
            var wrap = document.querySelector(id + '.allow-disabled');

            if (!wrap) {
                return [];
            }

            var formElemList = wrap.querySelectorAll('.form-input input, .form-input textarea, .form-input select');
            return formElemList;
        }

        function toggleDisableElem(disabled) {
            return function(formElemList) {
                Array.from(formElemList).forEach(function(elem) {
                    elem.disabled = disabled;

                    !elem.classList.contains('select-disabled') &&
                    $(elem).data("kendoDropDownList") &&
                        $(elem).data("kendoDropDownList").enable(!disabled);
                });
            };
        }

        var setDisabled = toggleDisableElem(true);
        var setEnabled = toggleDisableElem(false);

        function hideEl(index, $el) {
            var id = getToggleSel($el);
            $(id).addClass('d-none');

            setDisabled(getFormElem(id));
        };

        function hideAll() {
            $dt.each(hideEl);
        };

        function showEl($el) {
            var id = getToggleSel($el);
            $(id).removeClass('d-none');
            setEnabled(getFormElem(id));
        };

        function updateDeliveryOptionsPrice($el) {
            var id = getToggleSel($el);
            var postcode = $(id).find('.postcode').val();
            var dynamic = $(id).find('.dynamic-postcode');

            postcode &&
                ( resetShippingTotal()
                , getDeliveryPriceFromApi(postcode));

            dynamic &&
            dynamic.length > 0 &&
                resetShippingTotal();
        };

        function onDeliveryToChange(e) {
            var el = $(e.currentTarget);
            hideAll();
            showEl(el);

            updateDeliveryOptionsPrice(el);
        };

        function onPostcodeChangeUpdateDelivery(e) {
            var postcode = e.currentTarget.value;

            postcode &&
            postcode.length === 4 &&
            getDeliveryPriceFromApi(postcode);
        }

        $dt.on('change', onDeliveryToChange);
        $dynamicPostcode.on('keyup', onPostcodeChangeUpdateDelivery);
    },

    updateContactInfo: function() {
        var wrap = document.querySelector('[data-toggle="toggleAlternativeContactCB"]:not(.disable-not-allowed)');
        var $wrap = $(wrap);
        var $ac = Core.PortalCheckoutUpdateShippingCost.Cache.$addAlternateContact;
        var formElemList = wrap ? wrap.querySelectorAll('.form-input input, .form-input textarea') : [];

        function toggleElem(disabled) {
            return function() {
                Array.from(formElemList).forEach(function(elem) { elem.disabled = disabled; });
            };
        }

        var setDisabled = toggleElem(true);
        var setEnabled = toggleElem(false);


        function doToggleFormDisable() {
            ($wrap.hasClass('toggle-cb-content'))
                ? setDisabled()
                : setEnabled();
        }

        function onDeliveryToContactPersonChange() {
            $wrap.toggleClass('toggle-cb-content');
            doToggleFormDisable();
        }

        $ac.on('change', onDeliveryToContactPersonChange);
        doToggleFormDisable();
    }
};

Core.PortalPlayoutCart = {
    init: function () {
        Core.PortalCheckout.Cache = {
            $togglePlayout: $('a#toggle-cart')
        };

        this.toggleCartPlayout();
    },

    toggleCartPlayout: function () {
        Core.PortalCheckout.Cache.$togglePlayout.on('click', function (e) {
            e.preventDefault();
            var $el = $(this),
                $cartDesktop = $el.siblings('.cart-playout'),
                $cartMobile = $('#cart-playout-mobile');

            if ($cartDesktop.css('display') === "block") {
                $cartDesktop.css('display', 'none');
            } else {
                $cartDesktop.css('display', 'block');
            }

            if ($cartMobile.css('display') === "block") {
                $cartMobile.slideUp(300);
            } else {
                $cartMobile.slideDown(300);
            }

        });
    }
};

Core.FlyoutButtons = {
    init: function () {
        Core.FlyoutButtons.Cache = {
            $togglePlayoutClose: $('.cart-playout .cart-playout--close'),
            $togglePlayoutCloseMobile: $('#cart-playout-mobile .cart-playout--close'),
            $removeItem: $('.table-yourcart .table-btnremove')
        };

        this.togglePlayoutClose();
        this.togglePlayoutCloseMobile();
        this.removeCartItem();
    },

    togglePlayoutClose: function () {
        Core.FlyoutButtons.Cache.$togglePlayoutClose.on('click', function (e) {
            e.preventDefault();

            // for desktop
            $(this).parents('.cart-playout').slideToggle(0);

            // for mobile
            var $cartMobile = $('#cart-playout-mobile');
            if ($cartMobile.css('display') === "block") {
                $cartMobile.css('display', 'none');
            } else {
                $cartMobile.css('display', 'block');
            }
        });
    },

    togglePlayoutCloseMobile: function () {
        Core.FlyoutButtons.Cache.$togglePlayoutCloseMobile.on('click', function (e) {
            e.preventDefault();

            // for desktop
            Core.FlyoutButtons.Cache.$togglePlayoutClose.parents('.cart-playout').slideToggle(0);

            // for mobile
            var $cartMobile = $('#cart-playout-mobile');
            if ($cartMobile.css('display') === "block") {
                $cartMobile.slideUp(300);
            } else {
                $cartMobile.slideDown(300);
            }
        });
    },

    removeCartItem: function () {
        Core.FlyoutButtons.Cache.$removeItem.on('click', function (e) {
            e.stopPropagation();
            var $el = $(this),
                id = $el.attr('data-id'),
                $table = $el.closest('.table-yourcart');

            Core.PortalCheckout.deleteItem(id, function (response) {
                Core.PortalCheckout.propagateIsInvalidShipping(response);

                Core.PortalCheckout.refreshItems();
                Core.FlyoutButtons.removeItemRow($el.closest('tr.table-yourcart-row-item'));
            });

        });
    },

    removeItemRow: function ($row) {
        var $table = $row.closest('.table-yourcart');
        $row.remove();

        //if there's no item left, delete whole section (buy, rent, or rent-to-own)
        if ($table.find('tr.table-yourcart-row-item').length === 0) {
            $table.remove();
        }
    }
};

Core.CartFlyout = {
    init: function () {
        Core.CartFlyout.Cache = {
            $flyoutCart: $(".cart-playout"),
            $flyoutCartMobile: $("#cart-playout-mobile"),
            $cartAmount: $(".toggle-cart-btn .amount")
        }

        this.loadCartFlyout();
        this.initListenerClearCart();
    },
    initListenerClearCart: function() {
        var _self = this;
        var clearCart = function() { _self.clearCart() };

        document.removeEventListener('aidacare.clearcart', clearCart);
        document.addEventListener('aidacare.clearcart', clearCart);
    },

    loadCartFlyout: function () {
        $.ajax({
            type: "GET",
            url: '/Cart/GetItems',
            data: {
                cart: "Default"
            },
            success: function (response) {
                var portalCartObject = response;

                Core.CartFlyout.Cache.$flyoutCart.html("");
                var portalCartTemplate = Handlebars.compile($('#portalCartTemplate').html());
                var portalCartHTML = portalCartTemplate(portalCartObject);
                var productsPurchasedLen = portalCartObject.length;

                Core.CartFlyout.Cache.$flyoutCart.append(portalCartHTML);

                setTimeout(function () {
                    var $totalOfProduct = $('#siteHeader .toggle-cart tr.table-yourcart-row-item');
                    if ($totalOfProduct.length > 0) {
                        var sum = 0;
                        for (var a = 0; a < $totalOfProduct.length; a++) {
                            sum = sum + parseInt($($totalOfProduct[a]).attr("data-qty"));
                        }
                        Core.CartFlyout.Cache.$cartAmount.html(sum).show();
                    } else {
                        Core.CartFlyout.resetCart();
                    }

                    Core.CartFlyout.Cache.$flyoutCartMobile.html(Core.CartFlyout.Cache.$flyoutCart.html());
                    Core.FlyoutButtons.init();
                }, 100);
            }
        });
    },

    hideCartAmount: function() {
        $("a#toggle-cart .amount").html("").hide();
    },

    setYourCartEmpty: function() {
        var YOUR_CART_IS_EMPTY_HTML = '<div class="cart-playout--emptymessage">Your cart is empty.</div>';
        $('.cart-playout--content').html(YOUR_CART_IS_EMPTY_HTML);
    },

    resetCart: function() {
        Core.CartFlyout.hideCartAmount();
        Core.CartFlyout.setYourCartEmpty();
    },

    clearCart: function() {
        var _self = this;
        $.post('/cart/removeall').done(function() { _self.resetCart(); });
    },
};

Handlebars.registerHelper('portalCartObjectTypeLabel', function (portalCartObject, label) {
    for (var i = 0; i < portalCartObject.length; i++) {
        if (portalCartObject[i]['PriceType'] == label) {
            return true;
        }
    }

    return false;
});

Handlebars.registerHelper('portalCartObjectType', function (portalCartObject, type) {
    if (portalCartObject.PriceType == type) {
        return true;
    }
    return false;
});

Handlebars.registerHelper('portalCartObjectTypeTotal', function (portalCartObject, label) {
    var total = 0;

    for (var i = 0; i < portalCartObject.length; i++) {
        if (portalCartObject[i]['PriceType'] == label) {
            total += portalCartObject[i]['LineItemTotal'];
        }
    }

    return Core.PortalCheckout.formatMoney(total, 2, '$', ',', '.');
});
